var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"nav-bar basic"},[_c('p',[_vm._v(_vm._s(_vm.$t('shared.labels.new-inquiry')))])]),_c('div',{staticClass:"main"},[_c('inquiry-form')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }